import React from "react";
import { Link } from "react-router-dom";
import { get, isEmpty, uniqBy } from "lodash";
import { Typography, Tooltip } from "@material-ui/core";
import Info from "@material-ui/icons/InfoOutlined";
import {
  ALTERNATE_TITLES,
  TITLE_BAR_COLUMNS,
  getTitleTypeGroup,
} from "../../constants/ContentFinder";


const renderColumnValue = (column, titleDetails) => {
  if (column.getValue) {
    return column.getValue(titleDetails);
  }
  const raw = column.path ? get(titleDetails, column.path, "-") : "-";
  return column.format ? column.format(raw) : raw;
};

const ContentFinderTitleBar = ({
  titleDetails,
  columns = TITLE_BAR_COLUMNS,
}) => {
  if (isEmpty(titleDetails)) return null;

  const titleName = get(titleDetails, "TitleName", "");
  const otherNames = uniqBy(
    get(titleDetails, "OtherNames", []),
    "TitleName"
  );
  const group = getTitleTypeGroup(titleDetails);

  const visibleColumns = columns.filter(
    (column) => group && column.show.includes(group)
  );

  const alternateTitlesTooltip = (
    <>
      <Typography className="alternate-titles-title">
        {ALTERNATE_TITLES.title}
      </Typography>
      {isEmpty(otherNames) ? (
        <Typography className="alternate-titles-empty">
          {ALTERNATE_TITLES.error}
        </Typography>
      ) : (
        <ul className="alternate-titles-list">
          {otherNames.map((name: any, idx: number) => (
            <li key={`${get(name, "TitleName", "")}_${idx}`}>
              {get(name, "TitleName", "-")}
            </li>
          ))}
        </ul>
      )}
    </>
  );

  return (
    <div className="content-finder-title-bar">
      <div className="series-details-header">
        <Typography className="series-title-name">{titleName}</Typography>
        <Tooltip
          title={alternateTitlesTooltip}
          interactive
          arrow
          placement="bottom"
          classes={{ tooltip: "alternate-titles-tooltip" }}
        >
          <Info className="tableHeaderIcon titlesHelperIcon" />
        </Tooltip>
      </div>

      <div className="series-detail-rows">
        {visibleColumns.map((column) => {
          const value = renderColumnValue(column, titleDetails);
          return (
            <div className="series-detail-item" key={column.id}>
              <div className="series-detail-label">{column.label}</div>
              <div className="series-detail-value">
                {column.isLink && column.getLinkPath ? (
                  <Link
                    to={column.getLinkPath(titleDetails)}
                    className="contentFinderTableCellLink"
                  >
                    {value}
                  </Link>
                ) : (
                  value
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ContentFinderTitleBar;
